import { trpc } from 'api'
import { useCustomer } from './useSession'
import { useMemo } from 'react'

const useCustomerInvoice = () => {
  const customer = useCustomer()
  const addresses = trpc.customer.address.list.useQuery(undefined, {
    enabled: !!customer?.id,
  })

  const invoice = useMemo(() => {
    return addresses.data?.find((address) => address.type === 'invoice')
  }, [addresses.data])

  return {
    ...addresses,
    data: invoice,
  }
}

export default useCustomerInvoice
